import { render } from "./Index.vue?vue&type=template&id=858fa3de"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "858fa3de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('858fa3de', __exports__)) {
    console.log('reload')
    api.reload('858fa3de', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=858fa3de", () => {
    console.log('re-render')
    api.rerender('858fa3de', render)
  })

}


export default __exports__